/** @file Track the app's layout */
import { createSelector, createSlice } from '@reduxjs/toolkit';
var initialState = {
    visualizationScale: null,
};
var layoutSlice = createSlice({
    name: 'layout',
    initialState: initialState,
    reducers: {
        setVisualizationScale: function (state, action) {
            state.visualizationScale = action.payload;
        },
    },
});
export var setVisualizationScale = layoutSlice.actions.setVisualizationScale;
var selectSelf = function (state) { return state.layout; };
export var getVisualizationScale = createSelector(selectSelf, function (state) { return state === null || state === void 0 ? void 0 : state.visualizationScale; });
export default layoutSlice.reducer;
